import * as requestFromServer from "./StudentPreInterviewsCrud";
import { callTypes, studentPreInterviewSlice } from "./StudentPreInterviewsSlice";

const {actions} = studentPreInterviewSlice;

export const getStudentPreInterviews = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudentPreInterviews(queryParams)
    .then(response => {
      dispatch(actions.interviewsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllStudentPreInterviews = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllStudentPreInterviews(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getInterviews = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getInterviews(queryParams)
    .then(response => {
      dispatch(actions.interviewsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getPersonnels = term => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getPersonnels(term)
    .then(response => {
      dispatch(actions.personnelsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudentPreInterview = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewStudentPreInterview()
    .then(response => {
      dispatch(actions.preInterviewFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getStudentPreInterview(id)
    .then(response => {
      dispatch(actions.preInterviewFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getInterview = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getInterview(id)
    .then(response => {
      dispatch(actions.interviewFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveStudentPreInterview = preInterview => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveStudentPreInterview(preInterview)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const saveInterview = interview => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveInterview(interview)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deleteStudentPreInterviews = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteStudentPreInterviews(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanListState = () => dispatch => {
  dispatch(actions.listStateCleaned());
};

export const cleanInterviewState = () => dispatch => {
  dispatch(actions.interviewStateCleaned());
};

export const cleanStudentPreInterviewState = () => dispatch => {
  dispatch(actions.preInterviewStateCleaned());
};